enum WellputEventGoal {
    ACTION = 'action',
    ENGAGEMENT = 'engagement',
    SALE = 'sale'
}

export default WellputEventGoal;
